import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import {Module, ModuleFilter} from '../module.model';

export enum ModuleActionTypes {
  GetModules = '[Module] Get Modules',
  GetModulesByRegion = '[Module] Get Modules By Region',
  LoadModules = '[Module] Load Modules',
  AddModule = '[Module] Add Module',
  UpsertModule = '[Module] Upsert Module',
  AddModules = '[Module] Add Modules',
  UpsertModules = '[Module] Upsert Modules',
  UpdateModule = '[Module] Update Module',
  UpdateModules = '[Module] Update Modules',
  DeleteModule = '[Module] Delete Module',
  DeleteModules = '[Module] Delete Modules',
  ClearModules = '[Module] Clear Modules'
}

export class GetModules implements Action {
  readonly type = ModuleActionTypes.GetModules;

  constructor(public payload: { modules: null }) {}
}

export class GetModulesByRegion implements Action {
  readonly type = ModuleActionTypes.GetModulesByRegion;

  constructor(public payload: any = null) {}
}

export class LoadModules implements Action {
  readonly type = ModuleActionTypes.LoadModules;

  constructor(public payload: { modules: Module[] }) {}
}

export class AddModule implements Action {
  readonly type = ModuleActionTypes.AddModule;

  constructor(public payload: { module: Module }) {}
}

export class UpsertModule implements Action {
  readonly type = ModuleActionTypes.UpsertModule;

  constructor(public payload: { module: Module }) {}
}

export class AddModules implements Action {
  readonly type = ModuleActionTypes.AddModules;

  constructor(public payload: { modules: Module[] }) {}
}

export class UpsertModules implements Action {
  readonly type = ModuleActionTypes.UpsertModules;

  constructor(public payload: { modules: Module[] }) {}
}

export class UpdateModule implements Action {
  readonly type = ModuleActionTypes.UpdateModule;

  constructor(public payload: { module: Update<Module> }) {}
}

export class UpdateModules implements Action {
  readonly type = ModuleActionTypes.UpdateModules;

  constructor(public payload: { modules: Update<Module>[], from: ModuleFilter }) {}
}

export class DeleteModule implements Action {
  readonly type = ModuleActionTypes.DeleteModule;

  constructor(public payload: { id: string }) {}
}

export class DeleteModules implements Action {
  readonly type = ModuleActionTypes.DeleteModules;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearModules implements Action {
  readonly type = ModuleActionTypes.ClearModules;
}

export type ModuleActions =
 LoadModules
 | AddModule
 | UpsertModule
 | AddModules
 | UpsertModules
 | UpdateModule
 | UpdateModules
 | DeleteModule
 | DeleteModules
 | ClearModules
 | GetModules
 | GetModulesByRegion;
